"use client";

import * as React from "react";
import { NextUIProvider } from "@nextui-org/system";
import { UserContextProvider } from "@/library/entities/core/user/contexts/UserContext";

export function Providers({ children }) {
  return (
    <NextUIProvider className="">
      <UserContextProvider>
        {children}
      </UserContextProvider>
    </NextUIProvider>
  );
}
